import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { MatOptionSelectionChange } from "@angular/material/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Observable } from "rxjs";
import { debounceTime, startWith, switchMap, tap } from "rxjs/operators";

import { GenericComponent } from "../../components/generic.component";
import { StateDTO } from "../../models/state-dto";
import { StateService } from "src/app/core/services/state.service";
import { StateAutoCompleteFiltersDTO } from "../../models/state-auto-complete-filters-dto";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
@Component({
    selector: "app-smartfleet-state-auto-complete",
    templateUrl: "./state-auto-complete.component.html",
    styleUrls: ["./state-auto-complete.component.scss"],
    standalone: false
})
export class StateAutoCompleteComponent
  extends GenericComponent
  implements OnInit
{
  loading = false;
  _disabled = false;
  name = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.name
  });

  states: StateDTO[] = [];

  @Input() title = "";
  @Input() page = "";
  @Input() requiredText = "";
  @Input() countryId: number;
  @Output() onChange: any = new EventEmitter<StateDTO>();
  @Input() required = false;
  @Input() set disabled(value: boolean) {
    this._disabled = value;
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  constructor(
    private stateService: StateService,
    injector: Injector,
    private loadingDrivebService: LoadingDrivebService
  ) {
    super(injector);
  }

  ngOnInit() {
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "service-request":
          key = "srq-stateIdFilter";
          break;
        case "client-list":
          key = "cl-stateFilter";
          break;
        case "car-workshop":
          key = "cw-state";
          break;
        case "dashboard":
          key = "ds-state";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const state = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(state["name"]);
      }
    } else {
      this.clean();
    }
    this.name.valueChanges
      .pipe(
        debounceTime(200),
        tap(
          () => (
            (this.loading = true), this.loadingDrivebService.setAutoMode(false)
          )
        ),
        switchMap((value: string) => {
          if (value) {
            const filters = {} as StateAutoCompleteFiltersDTO;
            filters.name = value;
            filters.countryId = this.countryId;
            return this.stateService.findByFilters(filters);
          } else {
            this.loading = false;
            this.onChange.emit({} as StateDTO);
            return new Observable<StateDTO[]>();
          }
        })
      )
      .subscribe((data) => {
        this.states = data;
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
      });
  }

  handleStateChange(event: MatOptionSelectionChange, state: StateDTO) {
    if (event.isUserInput === true) {
      this.onChange.emit(state);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.states = [];
  }

  setValue(value: string): void {
    this.searchForm.get("name").setValue(value);
    this.states = [];
  }
}
